//
// Back To Top (JS)
// 2019-02-08
// Space-Time Inc.
//


(function () {
	var documentElement = document.documentElement;

	var btt = document.getElementById('backtotop');
	if (btt === null) return;

	var width   = btt.clientWidth;
	var height  = btt.clientHeight;
	var top     = btt.offsetTop;
	var footer  = document.getElementsByClassName('site-footer')[0];

	var update = function() {
		const style = getComputedStyle(btt.parentElement);
		btt.style.right = style.marginRight;

		var viewBottomY = documentElement.scrollTop + window.innerHeight - getWpAdminBarHeight();
		if (viewBottomY > footer.offsetTop) {
			btt.style.bottom = (viewBottomY - footer.offsetTop - 20) + 'px';
		} else {
			btt.style.bottom = '';
		}

		if (window.pageYOffset > window.innerHeight / 3) {
			btt.style.opacity = 1;
			btt.style.pointerEvents = 'auto';
		} else {
			btt.style.opacity = 0;
			btt.style.pointerEvents = 'none';
		}
	};
	window.addEventListener('resize', update);
	window.addEventListener('scroll', update);
	update();
	setTimeout(update, 100);


	// Utilities ---------------------------------------------------------------

	function getWpAdminBarHeight() {
		const wpab = document.getElementById('wpadminbar');
		return (wpab && getComputedStyle(wpab).position === 'fixed') ? wpab.offsetHeight : 0;
	}

})();
